import { render, staticRenderFns } from "./PaginaRespuestasBoleta.vue?vue&type=template&id=32e2a45f"
import script from "./PaginaRespuestasBoleta.vue?vue&type=script&lang=js"
export * from "./PaginaRespuestasBoleta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports